import useSearch from "hooks/useSearch";
import React, { useEffect, useRef } from "react";
import PropertyTypeFilterDropdown from "components/DropDown/PropertyTypeFilterDropdown";
import { ReactComponent as PropertyTypeFilterIcon } from "assets/icons/property_type_filter.svg";
import { ReactComponent as DropdownArrow } from "assets/icons/dropdown_arrow.svg";
import { motion } from "framer-motion";
import { useSearchParams } from "react-router-dom";
import {
  decodePropertyTypeDetails,
  encodePropertyTypeDetails,
  formatStringForUrl,
  reverseFormatPropertyTitle,
} from "utils/formatUrl";
import { propertyTypeDetailsList } from "utils/searchFilter";
import useSearchFilter from "hooks/useSearchFilter";

const PropertyTypeFilter = () => {
  const {
    selectedPropertyType,
    toggleFilterDropdown: togglePropertyTypeFilterDropdown,
    isFilterDropdownOpen,
    propertyTypeDetails,
    setPropertyTypeDetails,
    setSelectedPropertyType,
  } = useSearch();
  const { openFilterDropdownId, toggleFilterDropdown } = useSearchFilter();

  const [searchParams, setSearchParams] = useSearchParams();
  const buttonRef = useRef(null);

  const selectedPropertyTypeDetailsCount = propertyTypeDetails.filter(
    (checkbox) => checkbox.checked
  ).length;

  useEffect(() => {
    setSearchParams((prev) => {
      const newParams = new URLSearchParams(prev);
      newParams.set("propertyType", formatStringForUrl(selectedPropertyType));

      const hasCheckedDetails = propertyTypeDetails.some(
        (checkbox) => checkbox.checked
      );

      if (hasCheckedDetails) {
        newParams.set(
          "propertyTypeDetails",
          encodePropertyTypeDetails(propertyTypeDetails)
        );
      } else {
        newParams.delete("propertyTypeDetails");
      }

      return newParams;
    });
  }, [selectedPropertyType, propertyTypeDetails, setSearchParams]);

  // Initialize property values
  useEffect(() => {
    const initialPropertyType = searchParams.get("propertyType");
    const initialPropertyTypeDetails = searchParams.get("propertyTypeDetails");

    if (initialPropertyType) {
      setSelectedPropertyType(reverseFormatPropertyTitle(initialPropertyType));
    }

    if (initialPropertyTypeDetails) {
      const decodedPropertyTypeDetails = decodePropertyTypeDetails(
        initialPropertyTypeDetails,
        propertyTypeDetailsList
      );

      setPropertyTypeDetails(decodedPropertyTypeDetails);
    }
  }, []);

  return (
    <div className="min-w-fit">
      <div
        ref={buttonRef}
        className={`flex items-center justify-between min-w-fit space-x-3 px-[14px] cursor-pointer h-[42px] rounded-[8px] border border-[#F0EFFB] hover:bg-[#EAEAEA] transition-all duration-300 ease-in ${
          isFilterDropdownOpen ? "bg-[#EAEAEA]" : "bg-white"
        } ${selectedPropertyType ? "text-[#1DA1F2]" : "text-black"}`}
        onClick={(e) => {
          e.stopPropagation();
          // Close the filter dropdown if it is currently open
          if (openFilterDropdownId) {
            toggleFilterDropdown();
          }
          togglePropertyTypeFilterDropdown("searchFilter");
        }}
      >
        <div
          className={`mt-[1px] ${
            selectedPropertyType ? "text-[#1DA1F2]" : "text-black"
          }`}
        >
          <PropertyTypeFilterIcon />
        </div>
        <h3
          className={`font-semibold flex-shrink-0 leading-none text-[12px] ${
            selectedPropertyType ? "text-[#1DA1F2]" : "text-black"
          }`}
        >
          {selectedPropertyType}{" "}
          {selectedPropertyTypeDetailsCount > 1 &&
            `• (${selectedPropertyTypeDetailsCount})`}
        </h3>
        <motion.div
          className={`mt-[1px] ${
            selectedPropertyType ? "text-[#1DA1F2]" : "text-black"
          }`}
          animate={{ rotate: isFilterDropdownOpen ? 180 : 0 }}
          transition={{ duration: 0.3 }}
        >
          <DropdownArrow />
        </motion.div>{" "}
      </div>
      <PropertyTypeFilterDropdown
        style={{ borderRadius: 8, marginTop: 4, maxWidth: 350 }}
        id="searchFilter"
        buttonRef={buttonRef}
        direction="left"
      />
    </div>
  );
};

export default PropertyTypeFilter;
